import { createSelector } from 'reselect';

const selectDodProgramParticipants = (state: any) => state.dodProgramParticipants;


export const selectDodProgramParticipantsCurrentItem = createSelector([selectDodProgramParticipants], (dodProgramParticipants) => dodProgramParticipants.current);

export const selectDodProgramParticipantsListItems = createSelector([selectDodProgramParticipants], (dodProgramParticipants) => dodProgramParticipants.list);

export const selectItemById = (itemId: any) =>
    createSelector(selectDodProgramParticipantsListItems, (list) => list.result.items.find((item: any) => item._id === itemId));

export const selectDodProgramParticipantsQueryItems = createSelector([selectDodProgramParticipants], (dodProgramParticipants) => dodProgramParticipants.query);

export const selectDodProgramParticipantsCreatedItem = createSelector([selectDodProgramParticipants], (dodProgramParticipants) => dodProgramParticipants.create);

export const selectDodProgramParticipantsUpdatedItem = createSelector([selectDodProgramParticipants], (dodProgramParticipants) => dodProgramParticipants.update);

export const selectDodProgramParticipantsReadItem = createSelector([selectDodProgramParticipants], (dodProgramParticipants) => dodProgramParticipants.read);

export const selectDodProgramParticipantsDeletedItem = createSelector([selectDodProgramParticipants], (dodProgramParticipants) => dodProgramParticipants.delete);

export const selectDodProgramParticipantsSearchedItems = createSelector([selectDodProgramParticipants], (dodProgramParticipants) => dodProgramParticipants.search);

export const selectDodProgramParticipantsItemsCount = createSelector([selectDodProgramParticipants], (dodProgramParticipants) => dodProgramParticipants.count);

export const selectDodProgramParticipantsItemsFilter = createSelector([selectDodProgramParticipants], (dodProgramParticipants) => dodProgramParticipants.filter);